<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        Look up the density of diethyl ether and water in the
        <a
          href="https://sites.google.com/site/chempendix/Home?authuser=0"
          rel="noopener noreferrer"
          target="_blank"
          >Chempendix</a
        >. Compare the two densities.
      </p>

      <calculation-input
        v-model="inputs.input1"
        prepend-text="$\text{a) Diethyl ether}:$"
        append-text="$\text{g/mL}$"
        class="mb-3"
        :disabled="!allowEditing"
      />

      <calculation-input
        v-model="inputs.input2"
        prepend-text="$\text{b) Water}:$"
        append-text="$\text{g/mL}$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'ChemUCI51LBA1Q12',
  components: {
    CalculationInput,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
        input2: null,
      },
    };
  },
};
</script>
